// Grade helpers. The scorer produces a single 0–100 score and exposes two
// views of it: the canonical word grade (Excellent / Strong / Decent / Needs
// work / Critical issues) used by the strongly-ai-skills leaderboard, and a
// letter grade (A–F) for compact UI badges in strongly-ai-frontend.
//
// Both views derive from the same number — they never disagree.

import type { Grade, LetterGrade } from './rules/types';

export function gradeFor(score: number): Grade {
  if (score >= 92) return 'Excellent';
  if (score >= 80) return 'Strong';
  if (score >= 65) return 'Decent';
  if (score >= 45) return 'Needs work';
  return 'Critical issues';
}

export function letterGradeFor(score: number): LetterGrade {
  if (score >= 90) return 'A';
  if (score >= 75) return 'B';
  if (score >= 60) return 'C';
  if (score >= 40) return 'D';
  return 'F';
}
